<div class="row mb-4 faq-tile hover-hand" (click)="hidden=!hidden">
    <div class="col-12" [class]="hidden ? 'faq-section-collapsed' : 'faq-section-expanded'">
        <div class="faq-section">
            <p class="faq-question">{{Title}}</p>
            <p class="faq-answer" *ngIf="!hidden" [innerHTML]="Description">
            </p>
        </div>
    </div>
</div>